// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22b0927d","453":"e74a8f7c","455":"de234751","884":"c583999e"}[chunkId] + ".chunk.js";
};